<div class="expanded-chart">
  <div class="expanded-chart__header">
    <div class="expanded-chart__titles">
      <span class="expanded-chart__title">{{ title }}</span>
      @if (timeframeLabel) {
        <span class="expanded-chart__timeframe">{{ timeframeLabel }}</span>
      }
      @if (timeRangeLabel) {
        <span class="expanded-chart__range">{{ timeRangeLabel }}</span>
      }
    </div>

    <ui-button
      type="noBorderDefault"
      size="s"
      iconClass="ui-icon-cross"
      [matTooltip]="'COMMON.CLOSE' | translate"
      (clickAction)="close()"
    ></ui-button>
  </div>

  @if (response.data; as data) {
    <div class="expanded-chart__canvas">
      <app-chart-result-canvas
        [data]="data"
        [xAxisType]="response.xAxisType"
        [timeframe]="response.timeframe"
        [timezone]="response.timeRange?.timezone"
        [interactionHint]="'CHART_RESULT.CLICK_DETAILS' | translate"
        [isSelectionActionable]="isBarActionable"
        (barSelected)="onBarSelected($event)"
      ></app-chart-result-canvas>
    </div>
  }
</div>
